import { useState, useEffect } from "react";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";

import axiosIns from "../../axios";

const styles = {
  hero: {
    fontSize: "30px",
    fontWeight: 600,
  },
  contentBox: {
    marginTop: "20px",
    backgroundColor: "#fff",
    borderRadius: "20px",
    boxShadow: "rgb(115 82 199 / 18%) 0px 0.5rem 1.25rem",
  },
  boxHero: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px",
    borderBottom: "solid 1px #f1f1f1",
  },
  boxLabel: {
    fontSize: "16px",
    fontWeight: 500,
  },
  boxContent: {
    paddingBottom: "15px",
  },
  tableContainer: {
    boxShadow: "unset!important",
  },
  fields: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
  },
  field: {
    flex: "0 0 49%",
    maxWidth: "49%",
  },
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const validate = (values) => {
  const errors = {};

  if (!values.groupNameList) {
    errors.groupNameList = "Group Name List is required.";
  }

  if (!values.text) {
    errors.text = "Text is required.";
  }

  if (!values.messageType) {
    errors.messageType = "Type is required.";
  }

  if (!values.messagePlatform) {
    errors.messagePlatform = "Platform is required.";
  }

  if (!values.imageUrl) {
    errors.imageUrl = "Image Url is required.";
  }

  return errors;
};

const MessageContentModal = ({ handleClose, open, reload, selected }) => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      groupNameList: "",
      text: selected ? selected.text : "",
      messageType: selected ? selected.messageType : "",
      messagePlatform: selected ? selected.messagePlatform : "",
      imageUrl: selected ? selected.imageUrl : "",
    },
    validate,
    onSubmit: (values) => {
      if (selected) {
        axiosIns.put(`/message-contents/${selected.id}`, values).then((res) => {
          toast.success("Content updated..");

          handleClose();
          setTimeout(() => {
            reload();
          }, 1000);
        });
      } else {
        axiosIns.post("/message-contents", values).then((res) => {
          toast.success("Content added..");

          handleClose();
          setTimeout(() => {
            reload();
          }, 1000);
        });
      }
    },
  });

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <form onSubmit={formik.handleSubmit}>
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {selected ? "Edit Content" : "Add Content"}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Box sx={styles.fields}>
            <Box sx={{ ...styles.field, flex: "0 0 100%", maxWidth: "100%" }}>
              <TextField
                margin="normal"
                fullWidth
                label="Group Name List"
                name="groupNameList"
                autoFocus
                size="small"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.groupNameList}
                helperText={
                  formik.errors.groupNameList
                    ? formik.errors.groupNameList
                    : null
                }
              />
            </Box>
            <Box sx={styles.field}>
              <TextField
                margin="normal"
                fullWidth
                label="Message Platform"
                name="messagePlatform"
                size="small"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.messagePlatform}
                helperText={
                  formik.errors.messagePlatform
                    ? formik.errors.messagePlatform
                    : null
                }
              />
            </Box>
            <Box sx={styles.field}>
              <TextField
                margin="normal"
                fullWidth
                label="Message Type"
                name="messageType"
                size="small"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.messageType}
                helperText={
                  formik.errors.messageType ? formik.errors.messageType : null
                }
              />
            </Box>
            <Box sx={{ ...styles.field, flex: "0 0 100%", maxWidth: "100%" }}>
              <TextField
                margin="normal"
                fullWidth
                label="Text"
                name="text"
                size="small"
                multiline
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.text}
                helperText={formik.errors.text ? formik.errors.text : null}
              />
            </Box>
            <Box sx={{ ...styles.field, flex: "0 0 100%", maxWidth: "100%" }}>
              <TextField
                margin="normal"
                fullWidth
                label="Image Url"
                name="imageUrl"
                size="small"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.imageUrl}
                helperText={formik.errors.imageUrl ? formik.errors.imageUrl : null}
              />
            </Box>            
          </Box>
        </DialogContent>
        <DialogActions>
          <Button autoFocus type="submit">
            {selected ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </form>
    </BootstrapDialog>
  );
};

export default MessageContentModal;
